export default {
  'pet-profile:page:title': 'My Profile',
  'pet-profile:header:title': '<p>A</p> <p>Personal</p> <p>Selection</p>',
  'pet-profile:display:not-chosen': 'Not chosen',
  'pet-profile:display:breed-not-chosen': 'Breed: Not specified',
  'pet-profile:display:age-not-chosen': 'Age: Not specified',
  'pet-profile:display:needs-not-chosen': 'Need: Not specified',
  'pet-profile:display:food-type-not-chosen': 'Food type: Not specified',
  'pet-profile:display:your-pet': 'For your dog',
  'pet-profile:display:edit': 'Edit',
  'pet-profile:display:edit-your-pet-profile': 'Edit your personal profile',
  'pet-profile:display:edit-your-pet-profile:title:empty':
    'Create a profile for your pet',
  'pet-profile:display:edit-your-pet-profile:title:filled': 'Edit profile',
  'pet-profile:display:edit-your-pet-profile:subtitle':
    'For targeted product recommendations that really fit!',
  'pet-profile:display:food-preference': 'Food preference',
  'pet-profile:cdp:title': 'Wow! Recommendations - tailored to your needs',
  'pet-profile:cdp:title:cat': 'Recommendations for Your Cat',
  'pet-profile:no-petprofile-page:title':
    'Individual product recommendation in 3, 2, 1 …!',
  'pet-profile:no-petprofile-page:text': `Tell us the age, breed and special needs of your favorite and receive a personal product selection from us. {br}
        {br}
        Have you already ordered from us? Then log in to your existing account.`,
  'pet-profile:no-petprofile-page:start': 'Create food recommendation',
  'pet-profile:no-petprofile-page:login': 'Log in now',
  'pet-profile:header:your-pet': 'Your pet',
  'pet-profile:header:add-profile': 'Create another profile',
  'pet-profile:placeholder:dog-name': 'Your pet',
  'pet-profile:segmentation-update-sheet:weight-error':
    'Weight must be between {min} and {max} kg',
  'pet-profile:segmentation-update-sheet:name:placeholder': 'Enter name',
  'pet-profile:guide-change-pet-description':
    'Here you can switch between your profiles',
  'pet-profile:guide-edit-description':
    'For a better experience – give your pet a name!',
  'pet-profile:segmentation-update-sheet:delete-profile:button':
    'Delete this profile',
  'pet-profile:segmentation-update-sheet:delete-profile:title': 'Are you sure?',
  'pet-profile:segmentation-update-sheet:delete-profile:text:with-pet-name':
    "Are you sure you want to delete {petName}'s profile? This action cannot be undone.",
  'pet-profile:segmentation-update-sheet:delete-profile:text:without-pet-name':
    'Are you sure you want to delete your personal profile? This action cannot be undone.',
  'pet-profile:segmentation-update-sheet:delete-profile:confirm': 'Yes, delete',
  'pet-profile:segmentation-update-sheet:delete-profile:cancel': 'Cancel',
  'pet-profile:error:duplicate-name':
    'You already have an existing profile with this name.',
  'pet-profile:error:name-required': 'Please enter a name.',

  'pet-profile:feed-type-selector:title': 'Food Type & Consistency',
  'pet-profile:feed-type-selector:wet_food': 'Wet Food',
  'pet-profile:feed-type-selector:dry_food': 'Dry Food',
  'pet-profile:feed-type-selector:snacks': 'Snacks',
  'pet-profile:feed-type-selector:wet_food:sauce': 'Sauce',
  'pet-profile:feed-type-selector:wet_food:pate': 'Pate',
  'pet-profile:feed-type-selector:wet_food:cream': 'Cream',
  'pet-profile:feed-type-selector:wet_food:description:sauce':
    'Sauce Menu, Juicy Filet',
  'pet-profile:feed-type-selector:wet_food:description:pate':
    'Pure Meat, Filet Menu, Meaty Pate',
  'pet-profile:feed-type-selector:wet_food:description:cream': 'Silky Cream',
  'pet-profile:feed-type-selector:consistency-title': 'Consistency',
  'pet-profile:feed-type-selector:consistency:sauce': 'Sauces',
  'pet-profile:feed-type-selector:consistency:pate': 'Pate',
  'pet-profile:feed-type-selector:consistency:cream': 'Cream',
  'pet-profile:feed-type-selector:consistency:sauce:saucen-menu': 'Sauce Menu',
  'pet-profile:feed-type-selector:consistency:sauce:juicyfilets': 'Juicy Filet',
  'pet-profile:feed-type-selector:consistency:pate:puremeat': 'Pure Meat',
  'pet-profile:feed-type-selector:consistency:pate:filet-menu': 'Filet Menu',
  'pet-profile:feed-type-selector:consistency:pate:meatypate': 'Meaty Pate',
  'pet-profile:feed-type-selector:consistency:cream:silkycream': 'Silky Cream',
  'pet-profile:feed-type-selector:consistency:all': 'All Consistencies',

  'pet-profile:taste-selector:title': 'Preferred Taste',
  'pet-profile:taste-selector:description':
    'Choose the taste that your cat likes best',
  'pet-profile:no-pet-profile:title:dog': "Looking for your dog's profile?",
  'pet-profile:no-pet-profile:title:cat': "Looking for your cat's profile?",
  'pet-profile:no-pet-profile:title:name': "Looking for {name}'s profile?",
};
